// extracted by mini-css-extract-plugin
export default {"wrapperButtonStep":"button-submit-step_wrapperButtonStep__4ugM9","gray":"button-submit-step_gray__+MMma"};